
<div *ngIf="loading === 0 && data" class="container-fluid" style="padding-bottom:50px">
    <div class="row cz-item-header">
        <div class="col-md-12 text-center">
            <h2 class="h2-item-header">Übersicht</h2>
        </div>
    </div>
    <div class="row cz-item-header" style="margin-top:20px">
        <div class="col-md-4 text-right">
        </div>
        <div class="col-md-4 text-center">
            <dx-button icon="remove"
                       type="danger"
                       text="Zurück"
                       (onClick)="onAbbruch()">
            </dx-button>
        </div>
    </div>
    <div class="row" style="margin-top:10px" *ngIf="data.erlaubnisFiles && data.erlaubnisFiles.length">
        <div class="col-md-12">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <dx-data-grid [dataSource]="data.erlaubnisFiles"
                              [wordWrapEnabled]="true"
                              [columnAutoWidth]="true"
                              [showRowLines]="true"
                              [showBorders]="true">
                    <dxi-column [width]="200" alignment="center" cellTemplate="erlaubnisDownloadTemplate"></dxi-column>
                    <dxi-column [width]="150" alignment="center" dataField="created" dataType="date" format="dd.MM.yyyy" caption="Erstellungsdatum"></dxi-column>
                    <dxi-column dataField="sammelBezeichnung" caption="Typ"></dxi-column>
                    <div *dxTemplate="let gridData of 'erlaubnisDownloadTemplate'">
                        <a class="btn btn-success btn-sm" data-title="Download" (click)="download(gridData.data.name, gridData.data.sammelBezeichnung)">
                            <span class="glyphicon glyphicon-download"></span> Download
                        </a>
                    </div>
                </dx-data-grid>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
    <div class="row" style="margin-top:30px">
        <div class="col-md-12">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <dx-form [formData]="data.ansprechpartner"
                         [readOnly]="true"
                         [labelLocation]="'left'">
                    <dxi-item itemType="group" [caption]="'Ansprechpartner'" [colCount]="2">
                        <dxi-item [colSpan]="1" dataField="ansprechpartnerName" [label]="{text: 'Name'}" [editorOptions]="{ maxLength: 199 }"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="ansprechpartnerVorname" [label]="{text: 'Vorname'}" [editorOptions]="{ maxLength: 199 }"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="ansprechpartnerTelefon" [label]="{text: 'Telefon'}" [editorOptions]="{ maxLength: 199 }"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="ansprechpartnerEmail" [label]="{text: 'Email'}" [editorOptions]="{ maxLength: 99 }"></dxi-item>
                    </dxi-item>
                </dx-form>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
    <div class="row" style="margin-top:30px">
        <div class="col-md-12">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <dx-form [formData]="data.heStamm"
                         [readOnly]="true"
                         [labelLocation]="'left'">
                    <dxi-item itemType="group" [caption]="'Einrichtung Stammdaten'" [colCount]="2">
                        <dxi-item [colSpan]="1" dataField="name" [label]="{text: 'Name'}"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="angebotsGruppe" [label]="{text: 'Angebotsgruppe'}"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="strasse" [label]="{text: 'Straße'}"></dxi-item>
                        <dxi-item [colSpan]="1" dataField="ort" [label]="{text: 'Ort'}"></dxi-item>
                    </dxi-item>
                </dx-form>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
    <div class="row" style="margin-top:30px">
        <div class="col-md-12">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <dx-form [formData]="p"
                         [readOnly]="true"
                         [labelLocation]="'left'">
                    <dxi-item itemType="group" [caption]="'pädagogische Leitungen'">
                        <dxi-item [colSpan]="2" name="info">
                            <div>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </div>
        </div>
        <div style="margin-top:30px" *ngFor="let pl of data.paedLs; let u = index">
            <div class="col-md-12">
                <div class="col-md-2"></div>
                <div class="col-md-9">
                    <dx-form [formData]="pl"
                             [readOnly]="true"
                             [labelLocation]="'left'">
                        <dxi-item itemType="group" [caption]="getPersonalCaption(pl, u)" [colCount]="2">

                            <dxi-item [colSpan]="2" itemType="group" [caption]="'Leitungen'">
                                <dxi-item name="info">
                                    <div>
                                        <dx-data-grid [dataSource]="pl.leitungen"
                                                      [wordWrapEnabled]="true"
                                                      [columnAutoWidth]="true"
                                                      [showRowLines]="true"
                                                      [showBorders]="true">

                                            <dxi-column dataField="name" caption="Name"></dxi-column>
                                            <dxi-column [width]="150" alignment="center" dataField="beginnTaetigkeit" dataType="date" format="dd.MM.yyyy" caption="Beginn der Tätigkeit"></dxi-column>
                                            <dxi-column [width]="150" dataField="anteil" caption="Anteil"></dxi-column>

                                        </dx-data-grid>
                                    </div>
                                </dxi-item>
                            </dxi-item>

                            <dxi-item [colSpan]="2" itemType="group" [caption]="'Beruflicher Werdegang'" *ngIf="!pl.isDummy">
                                <dxi-item name="info">
                                    <div>
                                        <dx-data-grid [dataSource]="pl.lebenslauf"
                                                      [wordWrapEnabled]="true"
                                                      [columnAutoWidth]="true"
                                                      [showRowLines]="true"
                                                      [showBorders]="true">

                                            <dxi-column dataField="beschreibung" caption="Beschreibung"></dxi-column>
                                            <dxi-column [width]="120" dataField="von" caption="Von" dataType="date" format="dd.MM.yyyy"></dxi-column>
                                            <dxi-column [width]="120" dataField="bis" caption="Bis" [calculateCellValue]="calculateCellValue_Bis"></dxi-column>

                                        </dx-data-grid>
                                    </div>
                                </dxi-item>
                            </dxi-item>

                            <dxi-item [colSpan]="2" itemType="group" *ngIf="pl.wirdNachgereicht && !pl.isDummy" [caption]="'Zeugnisse'">
                                <dxi-item [colSpan]="2" name="info">
                                    <div>
                                        <strong class="text-danger">Wird Nachgereicht</strong>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item [colSpan]="2" itemType="group" *ngIf="!pl.wirdNachgereicht && !pl.isDummy" [caption]="'Zeugnisse'">
                                <dxi-item name="info">
                                    <div>
                                        <dx-data-grid [dataSource]="pl.files"
                                                      [wordWrapEnabled]="true"
                                                      [columnAutoWidth]="true"
                                                      [showRowLines]="true"
                                                      [showBorders]="true">

                                            <dxi-column [width]="200" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" cellTemplate="commandsTemplate"></dxi-column>
                                            <dxi-column [width]="150" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" dataField="created" dataType="date" format="dd.MM.yyyy" caption="Erstellungsdatum"></dxi-column>
                                            <dxi-column dataField="orgFileName" caption="Datei"></dxi-column>

                                            <div *dxTemplate="let gridData of 'commandsTemplate'">
                                                <div *ngIf="!gridData.data.toDelete">
                                                    <a class="btn btn-info btn-sm" data-title="Download" (click)="download(gridData.data.name, gridData.data.bezeichnung )">
                                                        <span class="glyphicon glyphicon-download"></span> Download
                                                    </a>
                                                    <cz-document-viewer-popup [fileName]="gridData.data.name" [smallBtn]="false"></cz-document-viewer-popup>
                                                </div>
                                            </div>
                                        </dx-data-grid>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
                <div class="col-md-1"></div>
            </div>
        </div>
    </div>
    <div style="margin-top:30px" *ngFor="let ue of data.ues; let i = index">
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <dx-form [formData]="ue"
                             [readOnly]="true"
                             [labelLocation]="'left'">
                        <dxi-item itemType="group" [caption]="getEinrichtungsteilCaption(ue, i)" [colCount]="2">
                            <dxi-item [colSpan]="1" dataField="name" [label]="{text: 'Name'}"></dxi-item>
                            <dxi-item [colSpan]="1" dataField="angebotsForm" [label]="{text: 'Angebotsform'}"></dxi-item>
                            <dxi-item [colSpan]="1" dataField="strasse" [label]="{text: 'Straße'}"></dxi-item>
                            <dxi-item [colSpan]="1" dataField="ort" [label]="{text: 'Ort'}"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
                <div class="col-md-1"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-2"></div>
                <div class="col-md-9">
                    <dx-form [formData]="ue"
                             [readOnly]="true"
                             [labelLocation]="'left'">
                        <dxi-item itemType="group" [colCount]="10" *ngIf="!ue.konzeptionWirdNachgereicht" [caption]="'Konzeption'">
                            <dxi-item [colSpan]="2" dataField="konzeptionDate" editorType="dxDateBox" [label]="{text: 'Mit Stand vom'}"></dxi-item>
                            <dxi-item [colSpan]="8" itemType="empty"></dxi-item>
                            <dxi-item [colSpan]="10" dataField="konzeptionArt1" editorType="dxCheckBox" [editorOptions]="{ text: 'zu Verfahren der Beteiligung sowie Möglichkeiten der Beschwerde für Kinder und Jugendliche (§ 45 Abs. 2 Punkt 3. SGB VIII)' }">
                                <dxo-label [visible]="false">
                                </dxo-label>
                            </dxi-item>
                            <dxi-item [colSpan]="10" dataField="konzeptionArt2" editorType="dxCheckBox" [editorOptions]="{ text: 'über Maßnahmen zur Qualitätsentwicklung und -sicherung (§ 45 Abs. 3 Punkt 1. SGB VIII)' }">
                                <dxo-label [visible]="false">
                                </dxo-label>
                            </dxi-item>
                            <dxi-item [colSpan]="10" dataField="konzeptionArt3" editorType="dxCheckBox" [editorOptions]="{ text: 'Gewaltschutzkonzeption' }">
                                <dxo-label [visible]="false">
                                </dxo-label>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" *ngIf="ue.konzeptionWirdNachgereicht" [caption]="'Konzeption'">
                            <dxi-item [colSpan]="2" name="info">
                                <div>
                                    <strong class="text-danger">Wird Nachgereicht</strong>
                                </div>
                            </dxi-item>
                        </dxi-item>
                        <dxi-item [colSpan]="2" name="info" *ngIf="!ue.konzeptionWirdNachgereicht">
                            <div>
                                <dx-data-grid [dataSource]="ue.konzeptionFiles"
                                              [wordWrapEnabled]="true"
                                              [columnAutoWidth]="true"
                                              [showRowLines]="true"
                                              [showBorders]="true">

                                    <dxi-column [width]="200" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" cellTemplate="commandsTemplate"></dxi-column>
                                    <dxi-column [width]="150" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" dataField="created" dataType="date" format="dd.MM.yyyy" caption="Erstellungsdatum"></dxi-column>
                                    <dxi-column dataField="orgFileName" caption="Datei"></dxi-column>

                                    <div *dxTemplate="let gridData of 'commandsTemplate'">
                                        <div *ngIf="!gridData.data.toDelete">
                                            <a class="btn btn-info btn-sm" data-title="Download" (click)="download(gridData.data.name, gridData.data.bezeichnung )">
                                                <span class="glyphicon glyphicon-download"></span> Download
                                            </a>
                                            <cz-document-viewer-popup [fileName]="gridData.data.name" [smallBtn]="false"></cz-document-viewer-popup>
                                        </div>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
                <div class="col-md-1"></div>
            </div>
        </div>

        <div class="row" style="margin-top:30px">
            <div class="col-md-12">
                <div class="col-md-2"></div>
                <div class="col-md-9">
                    <dx-form [formData]="p"
                             [readOnly]="true"
                             [labelLocation]="'left'">
                        <dxi-item itemType="group" [caption]="'Personal'">
                            <dxi-item [colSpan]="2" name="info">
                                <div>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>

            <div style="margin-top:30px" *ngFor="let p of ue.personal; let u = index">
                <div class="col-md-12" style="margin-top:20px">
                    <div class="col-md-3"></div>
                    <div class="col-md-8">
                        <dx-form [formData]="p"
                                 [readOnly]="true"
                                 [labelLocation]="'left'">
                            <dxi-item itemType="group" [caption]="getPersonalCaption(p, u)">
                                <dxi-item [colSpan]="2" name="info">
                                    <div>
                                        <dx-data-grid [dataSource]="p.personalStellen"
                                                      [wordWrapEnabled]="true"
                                                      [columnAutoWidth]="true"
                                                      [showRowLines]="true"
                                                      [showBorders]="true">

                                            <dxi-column dataField="taetigkeit" caption="Tätigkeit"></dxi-column>
                                            <dxi-column [width]="150" alignment="center" dataField="beginnTaetigkeit" dataType="date" format="dd.MM.yyyy" caption="Beginn der Tätigkeit"></dxi-column>
                                            <dxi-column [width]="150" dataField="anteil" caption="Anteil"></dxi-column>
                                        </dx-data-grid>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                    </div>
                    <div class="col-md-1"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top:30px">
        <div class="col-md-12">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <dx-form [formData]="data.anhaenge"
                         [readOnly]="true"
                         [labelLocation]="'left'">
                    <dxi-item itemType="group" [caption]="'Anhänge'">
                        <dxi-item name="info">
                            <div>
                                <dx-data-grid [dataSource]="data.anhaenge"
                                              [wordWrapEnabled]="true"
                                              [columnAutoWidth]="true"
                                              [showRowLines]="true"
                                              [showBorders]="true">

                                    <dxi-column [width]="200" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" cellTemplate="commandsTemplate"></dxi-column>
                                    <dxi-column [width]="150" alignment="center" [allowResizing]="false" [allowFiltering]="false" [allowSorting]="false" dataField="created" dataType="date" format="dd.MM.yyyy" caption="Erstellungsdatum"></dxi-column>
                                    <dxi-column [width]="400" dataField="bezeichnung" caption="Typ"></dxi-column>
                                    <dxi-column dataField="orgFileName" caption="Datei"></dxi-column>

                                    <div *dxTemplate="let gridData of 'commandsTemplate'">
                                        <div *ngIf="!gridData.data.toDelete">
                                            <a class="btn btn-info btn-sm" data-title="Download" (click)="download(gridData.data.name, gridData.data.bezeichnung )">
                                                <span class="glyphicon glyphicon-download"></span> Download
                                            </a>
                                            <cz-document-viewer-popup [fileName]="gridData.data.name" [smallBtn]="false"></cz-document-viewer-popup>
                                        </div>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div *ngIf="loading === 1" class="text-center">
                <h1>Lade...</h1>
            </div>
            <div *ngIf="loading === 2" class="text-center">
                <h1>Speichere...</h1>
            </div>
        </div>
    </div>
</div>
